import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)',
)({ component: DetailLayout });

function DetailLayout() {
  // Shared chrome for /my-components/(styles|variants|skus)/$id pages.
  // Mirrors `/my-styles/(pages)/(detail)/route.tsx` — currently a passthrough.
  return <Outlet />;
}
